import { QueryBuilder, formatQuery } from 'react-querybuilder';
import { parseCEL } from 'react-querybuilder/parseCEL';
import 'react-querybuilder/dist/query-builder.css';
import React, { useCallback, useEffect, useState, useContext, useRef } from 'react';
import * as utils from "../../../components/utils.js";
 import { QueryBuilderBootstrap } from '@react-querybuilder/bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.scss';
//  import 'bootstrap/scss/bootstrap.scss';

const fields = [
    { name: 'firstName', label: 'First Name' },
    { name: 'lastName', label: 'Last Name' },
];

const Expression_Editor = ({ node, schemas, onChange, query }) => {
    const [q, setQ] = useState(query);
    const [t, setT] = useState(query ? formatQuery(query, "cel") : null);

    const _get_fields = () => {
        let _output = [];
        if (schemas) {
            for (var s of schemas) {
                if (s.schema) {
                    for (var f of s.schema) {
                        let _type = "text";
                        switch (f.fieldType) {
                            case "number":
                                {
                                    _type = "number";
                                }
                                break;
                            default: {
                                _type = "text";
                            }
                        }

                        _output.push({
                            name: `${utils.code_name(s.name)}.${utils.code_name(f.fieldName)}`,
                            // inputType: _type,
                            valueSources: ['field', 'value'],

                            label: `${utils.code_name(s.name)}.${utils.code_name(f.fieldName)}`
                        })
                    }
                }
            }
        }

        return _output;
    }

    const _notifyChange = () => {
        if (onChange) {
            onChange(q);
        }
    }

    useEffect(() => {
        _notifyChange();
        console.log("refresh");
    }, [q, t]);

    return (
        <>
            <textarea className="form-control" value={t} onChange={(e) => {
                try {
                    setQ(utils.clone(parseCEL(e.target.value)));
                }
                catch (err) {
                    console.log(err);
                    //nop
                }

                setT(utils.clone(e.target.value));
            }}>

            </textarea>
            <hr />
            <QueryBuilderBootstrap>
                <QueryBuilder
                    fields={_get_fields()} query={q}
                    onQueryChange={(p) => {
                        if (onChange) {
                            setQ(utils.clone(p));
                            try {
                                setT(utils.clone(formatQuery(p, "cel")));
                            }
                            catch(err) {
                                //nop
                            }
                        }
                    }} />
            </QueryBuilderBootstrap>
        </>);
}

export { Expression_Editor }